module.exports = __webpack_public_path__ + "img/center-details-data6.c7ce227d.png";